import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'osp-overlay-notification',
  standalone: true,
  templateUrl: './overlay-notification.component.html',
  styleUrl: './overlay-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayNotificationComponent {}
